import { gql } from '@apollo/client'
import { ListingInfoFragment } from '@src/graphql/fragment/listingInfo'

export default gql`
  query VerifyPlanet($planetID: String!) {
    getPlanet(planetID: $planetID) {
      listingInfo {
        ...ListingInfo # for update planet price
      }
      nftListingStatus # for sell planet
      owner {
        walletAddress # for buy / gift planet
      }
      planetID
      stage # for breed planets
    }
  }

  ${ListingInfoFragment}
`
